{
  "collect": "Kumpulkan Spesimen",
  "track": "Lacak Spesimen",
  "accession": "Nomor Aksesi",
  "barcode": "Kode Batang",
  "status": {
    "ordered": "Dipesan",
    "collected": "Terkumpul",
    "inTransit": "Dalam Pengiriman",
    "received": "Diterima",
    "processing": "Diproses",
    "resulted": "Hasil Tersedia",
    "rejected": "Rejected",
    "in_transit": "Dalam Pengiriman"
  },
  "title": "Specimens",
  "loading": "Loading specimens…",
  "errorState": "Could not load specimens.",
  "emptyState": "No specimens for this patient.",
  "noRejectionReason": "Rejected — no reason recorded",
  "columns": {
    "accession": "Accession",
    "type": "Type",
    "status": "Status",
    "collected": "Collected",
    "received": "Received",
    "location": "Location"
  }
}
